exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ch2-cart-heading h1[data-v-7141ec34]{font-size:40px;font-weight:700;margin-right:16px;line-height:40px;margin-bottom:3px}.ch2-cart-heading span[data-v-7141ec34]{font-size:13px}.ch2-cart-subheading[data-v-7141ec34]{margin-bottom:29px}.ch2-options-scroll-to[data-v-7141ec34]{color:#fff;position:fixed;bottom:80px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);padding:3px 35px 3px 14px;background-size:auto 16px;background:#000 url(/gfx/checkout2/ic_link-arrow.svg) no-repeat top 50% right 9px;font-size:17px;font-weight:700;border-radius:5px;text-decoration:none}", ""]);

// exports
